import { Injectable, OnDestroy } from '@angular/core'
import { Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import {
  focusPanelAction,
  RootState,
  setFocusedCWTransactions,
  setFocusedExtTransactions,
} from '@helios/state-management'
import { Actions, ofType } from '@ngrx/effects'
import { takeUntil } from 'rxjs/operators'
import { TransactionsKey } from '@helios/panels/transactions'

@Injectable()
export class TransactionFocusEffects implements OnDestroy {
  readonly _destroyed$ = new Subject<void>()

  constructor(
    private readonly store: Store<RootState>,
    private readonly actions$: Actions,
  ) {
    // filter for transactions from copilot
    this.actions$
      .pipe(takeUntil(this._destroyed$), ofType(setFocusedCWTransactions))
      .subscribe(action =>
        this.store.dispatch(focusPanelAction(TransactionsKey)),
      )

    this.actions$
      .pipe(takeUntil(this._destroyed$), ofType(setFocusedExtTransactions))
      .subscribe(action =>
        this.store.dispatch(focusPanelAction(TransactionsKey)),
      )
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }
}
